import _get from 'lodash/get'
import _isEqual from 'lodash/isEqual'
import { get as getConfig } from '../config/index'
import { getResolverData, setResolverLocation } from '../services/resolver/actions'
import { isAnonymousHome } from '../services/url/index'
import { getRoutes } from '../routes/index'

const config = getConfig()

/**
 * Dispatch resolver updates when the browser history changes.
 * Kept in its own module so Vite/Rollup cannot merge `run()` into this function body.
 * @param {object} options
 * @param {object} options.store Redux store
 * @param {object} options.location History location object
 */
export default function attachResolverHistoryListener ({ store, location }) {
  const { pathname } = location
  const { auth } = store.getState()
  const jwt = auth.get('jwt')
  if (_get(config, 'features.marketing.proxyAnonymousHome') && isAnonymousHome(pathname, jwt)) {
    window.location.reload()
  }
  const { resolver } = store.getState()
  if (pathname !== resolver.get('path')) {
    const routes = getRoutes()
    store.dispatch(getResolverData(location, routes))
  } else if (!_isEqual(location, resolver.get('location'))) {
    store.dispatch(setResolverLocation(location))
  }
}
